<template>
  <v-container
    fluid
    justify="center"
    style="
      max-width: 616px;
      background: white;
      padding-left: 16px;
      padding-right: 16px;
    "
  >
    <v-row v-if="passValidation">
      <v-col cols="12">
        <a @click="passValidation = false"> &#60; Indietro </a>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <h3 id="main-content" style="font-weight: bold">
          Comunicazione di un abbruciamento controllato destinata ai Vigili del Fuoco, al Comune, ai Carabinieri Forestali. 
        </h3>
        <p class="section-fitosanitari">Per abbruciamenti fitosanitari riguardanti il colpo di fuoco batterico seguire invece la procedura guidata <a style="font-size: 16px !important; color: rgba(0, 0, 0, 0.87);" href="https://agricoltura.regione.emilia-romagna.it/fitosanitario/difesa-sostenibile/abbruciamenti/abbruciamento-residui-vegetali-infetti-da-erwinia-amylovora" target="_blank">in questa pagina</a>.</p>
        <a
          v-if="
            fires &&
            fires.length > 0 &&
            !passValidation &&
            !postValidationOTP &&
            !postInsertBurningSignalSuccess
          "
          @click="goToAllFires"
        >
          &#60; Segnalazioni precedenti
        </a>
      </v-col>
    </v-row>

    <v-row class="my-10" v-if="isLoadingState">
      <v-col cols=12 style='text-align: center'>
        <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </v-col>
    </v-row>

    <v-row class="my-10" v-if="!isLoadingState && offline">
      <v-col cols=12>
        <h1 class="text-center">L’applicazione è temporaneamente offline.</h1>
        <h3 class="text-center">Ci scusiamo per il disagio. Le comunicazioni possono essere fatte tramite Numero Verde <b>800 841051</b> oppure via E-mail <a href="email:so.emiliaromagna@vigilfuoco.it">so.emiliaromagna@vigilfuoco.it</a></h3>
      </v-col>
    </v-row>
    <v-form
      v-if="!preAllarmPhase && !passValidation && !postValidationOTP && !postInsertBurningSignalSuccess && !offline"
      ref="form"
      v-model="valid"
      lazy-validation
    >

      <div v-if="warningState.enabled" class="allarmState" style="margin-top: 40px; margin-bottom: 20px;">
        <p style="font-weight: bold;">Disposta l’attivazione della FASE DI ATTENZIONE per gli incendi boschivi.</p>
        <p>Vige l’obbligo di spegnere i fuochi di residui vegetali derivanti dalla gestione agricolo-forestale entro le ore 11:00 di mattina, per quelle zone non coperte dallo stato di Grave Pericolosità (laddove presente) secondo il bollettino SETTIMANALE reperibile all’indirizzo:</p>
        <p><a style="font-size:16px !important" href="https://protezionecivile.regione.emilia-romagna.it/rischi-previsione-prevenzione/rischio-incendi/bollettini-incendi-boschivi" target="_blank">Bollettini incendi boschivi - Agenzia per la sicurezza territoriale e la protezione civile</a></p>
        <!--<span v-if="warningState.provinces.length > 0">applicato nelle province di</span>
          <ul v-if="warningState.provinces.length > 0">
            <li v-for="province in warningState.provinces" :key="province.sigla">{{ province.nome }}</li>
          </ul>
        <span v-if="warningState.zonaIBs.length > 0 && warningState.provinces.length > 0">e nelle zone di</span>
        <span v-else-if="warningState.zonaIBs.length > 0 && warningState.provinces.length <= 0">applicato nelle zone di</span>
        <ul v-if="warningState.zonaIBs.length > 0">
          <li v-for="zona in warningState.zonaIBs" :key="zona.id">{{ zona.description }}</li>
        </ul>-->
      </div>
      <div v-if="preAllarmState.enabled" class="allarmState" style="margin-top: 40px; margin-bottom: 20px;">
        <p style="font-weight: bold;">Dichiarata la GRAVE PERICOLOSITA’ per gli incendi boschivi.</p>
        <p>Vige il divieto per gli abbruciamenti controllati secondo le zone indicate nel Bollettino SETTIMANALE reperibile all’indirizzo:</p>
        <p><a style="font-size:16px !important" href="https://protezionecivile.regione.emilia-romagna.it/rischi-previsione-prevenzione/rischio-incendi/bollettini-incendi-boschivi" target="_blank">Bollettini incendi boschivi - Agenzia per la sicurezza territoriale e la protezione civile</a></p>
        <!--<span v-if="preAllarmState.provinces.length > 0">applicato nelle province di</span>
        <ul v-if="preAllarmState.provinces.length > 0">
          <li v-for="province in preAllarmState.provinces" :key="province.sigla">{{ province.nome }}</li>
        </ul>
        <span v-if="preAllarmState.zonaIBs.length > 0 && preAllarmState.provinces.length > 0">e nelle zone di</span>
        <span v-else-if="preAllarmState.zonaIBs.length > 0 && preAllarmState.provinces.length <= 0">applicato nelle zone di</span>
        <ul v-if="preAllarmState.zonaIBs.length > 0">
          <li v-for="zona in preAllarmState.zonaIBs" :key="zona.id">{{ zona.description }}</li>
        </ul>-->
      </div>

      <!-- box di errore di validazione --> 
      <v-col>
          <a name='anchorgenericAlertDataValidContent' />
          <v-alert id="genericAlertDataValidContent" icon=" " 
          type="error" role="alert" v-if="!dataValidContent">
            Dati non validi. Verificare i dati immessi.
          </v-alert>
      </v-col>

      <!-- NOME -->
      <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>Nome</h5>
        <div class='fuochi-tooltip-container'>
          <v-tooltip top :close-delay=tooltip.delay >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-help-circle</v-icon>
            </template>
            {{ tooltip.nameSurname }}
          </v-tooltip>
        </div>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-text-field
            ref="textfieldname"
            class="styled-input"
            v-model="fire.name"
            :aria-label="['Nome, '+tooltip.nameSurname]"
            :aria-invalid="[!fire.name]"
            required
            outlined
            :rules="[(v) => !!v || 'Campo obbligatorio']"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <!-- FINE NOME -->

      <!-- COGNOME -->
      <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>Cognome</h5>
        <div class='fuochi-tooltip-container'>
          <v-tooltip top :close-delay=tooltip.delay>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-help-circle</v-icon>
            </template>
            {{ tooltip.nameSurname }}
          </v-tooltip>
        </div>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="fire.surname"
            required
            outlined 
            :aria-label="['Cognome, '+tooltip.nameSurname]"
            :aria-invalid="[!fire.surname]"
            :rules="[(v) => !!v || 'Campo obbligatorio']"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <!-- FINE COGNOME -->

      <!-- SEGNALATORE -->
      <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>Segnalatore</h5>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-select
            :items="choicesSignaler"
            @change="verifyDates"
            v-model="fire.signaler"
            outlined
            aria-label="segnalatore"
            :aria-invalid="[!fire.signaler]"
            required
            :rules="[(v) => !!v || 'Campo obbligatorio']"
            :label="!fire.signaler ? 'Scegli' : ''"
          >
          </v-select>
        </v-col>
      </v-row>
      <!-- FINE SEGNALATORE -->

      <!-- CELLULARE -->
      <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>Cellulare</h5>
        <div class='fuochi-tooltip-container'>
          <v-tooltip top :close-delay=tooltip.delay>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-help-circle</v-icon>
            </template>
            {{ tooltip.phone }}
          </v-tooltip>
        </div>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-text-field
            type="number"
            v-model.number="fire.phone"
            required
            min="0"
            oninput="validity.valid||(value='');"
            outlined
            prefix="+39"
            :aria-label="['cellulare prefisso +39, '+tooltip.phone]"
            :aria-invalid="[!fire.phone]"
            :rules="[(v) => !!v || 'Campo obbligatorio']"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <!-- FINE CELLULARE -->

      <!-- EMAIL -->
      <!-- <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>Email (non obbligatorio)</h5>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="fire.email"
            outlined
            aria-label="Email (non obbligatorio)"
            :rules="[
              (v) =>
                v == null ||
                v.trim().length == 0 ||
                isEmailValid(v) ||
                'Il campo deve contenere un indirizio e-mail valido',
            ]"
          >
          </v-text-field>
        </v-col>
      </v-row> -->
      <!-- FINE EMAIL -->

      <!-- INIZIO INDIRIZZO -->
      <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>Indirizzo/Località</h5>
        <div class='fuochi-tooltip-container'>
          <v-tooltip top :close-delay=tooltip.delay>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-help-circle</v-icon>
            </template>
            {{ tooltip.address }}
          </v-tooltip>
        </div>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="fire.address"
            required
            outlined
            :aria-label="['indirizzo, '+tooltip.address]"
            :aria-invalid="[!fire.address]"
            :rules="[(v) => !!v || 'Campo obbligatorio']"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <!-- FINE INDIRIZZO -->

      <!-- INIZIO NUMERO CIVICO -->
      <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>Numero civico (non obbligatorio)</h5>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="fire.streetNumber"
            aria-label="numero civico (non obbligatorio)"
            outlined
          >
          </v-text-field>
        </v-col>
      </v-row>
      <!-- FINE NUMERO CIVICO -->

      <!-- INIZIO PROVINCE -->
      <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>Provincia</h5>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-autocomplete
            @change="loadDistricts"
            v-model="fire.province"
            :items="provinces"
            outlined
            aria-label="provincia"
            :aria-invalid="[!fire.province]"
            :label="!fire.province ? 'Scegli' : ''"
            required
            :rules="[(v) => !!v || 'Campo obbligatorio']"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <!-- FINE PROVINCE -->

      <!-- INIZIO COMUNE -->
      <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>Comune</h5>
        <div class='fuochi-tooltip-container'>
          <v-tooltip top :close-delay=tooltip.delay>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-help-circle</v-icon>
            </template>
            {{ tooltip.city }}
          </v-tooltip>
        </div>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-autocomplete
            v-model="selCity"
            @change="(el) => { fire.pair = false; fire.deroga = false; fire.dl6923Summer = false; fire.city = el.nome; checkIsPairPeriod(); checkIsDivietoDL692023(); checkIsDivietoEstivoDL692023(); }"
            :items="cities"
            item-text="nome"
            return-object
            outlined
            aria-label="comune"
            :aria-invalid="[!fire.city]"
            :disabled="!fire.province"
            :label="!fire.city ? 'Scegli' : ''"
            required
            :rules="[(v) => !!v || 'Campo obbligatorio']"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <!-- FINE COMUNE -->

      <!-- INIZIO CAP -->
      <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>CAP (non obbligatorio)</h5>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-text-field
            type="number"
            min="0"
            oninput="validity.valid||(value='');"
            v-model.number="fire.postalCode"
            aria-label="cap (non obbligatorio)"
            outlined
          >
          </v-text-field>
        </v-col>
      </v-row>
      <!-- FINE CAP -->

      <!-- DATE ACCENSIONE FUOCO -->
      <v-col class="nopaddingleft fuochi-field-label" cols="12">
        <h5>Accensione fuoco</h5>
        <div class='fuochi-tooltip-container'>
          <v-tooltip top :close-delay=tooltip.delay>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-help-circle</v-icon>
            </template>
            <p>{{ tooltip.datetime }}</p>
            <p style="margin: 0 !important">{{ tooltip.datetimeWarning }}</p>
          </v-tooltip>
        </div>
      </v-col>
      <!-- INIZIO data FUOCO -->
      <v-row>
        <v-datepickercalendar
          :min-date="getStartDateMin()"
          :max-date="getStartDateMax()"
          @input="verifyDates"
          @popoverDidHide="verifyDates"
          v-model="fire.dateStart"
          mode="dateTime"
          is24hr
        >
          <template v-slot="{ inputValue, inputEvents }">
            <v-text-field
              :value="formatDate(fire.dateStart)"
              v-on="inputEvents"
              readonly
              class="d-inline-block border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
              :aria-label="['Data e ora di inizio del fuoco, '+tooltip.datetime]"
              prefix="Inizio"
              outlined
              required
              :rules="[(v) => !!v || 'Campo obbligatorio']"
            ></v-text-field>
          </template>
        </v-datepickercalendar>
        <svg
          class="w-4 h-4 mx-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          width="25"
          heigth="25"
          style="margin-bottom: 20px"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M14 5l7 7m0 0l-7 7m7-7H3"
          />
        </svg>
        <v-datepickercalendar
          :min-date="getEndDateMin()"
          :max-date="getEndDateMax()"
          @input="verifyDates"
          @popoverDidHide="verifyDates"
          v-model="fire.dateEnd"
          mode="dateTime"
          is24hr
        >
          <template v-slot="{ inputValue, inputEvents }">
            <v-text-field
              :value="formatDate(fire.dateEnd)"
              v-on="inputEvents"
              readonly
              class="d-inline-block border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
              aria-label="Data e ora di fine del fuoco"
              prefix="Fine"
              outlined
              required
              :rules="[(v) => !!v || 'Campo obbligatorio']"
            ></v-text-field>
          </template>
        </v-datepickercalendar>
      </v-row>
      <!-- FINE DATE ACCENSIONE FUOCO -->

      <v-row v-if="selCity && (selCity.pair || selCity.cessato) && blockByDivietoDL692023">
        <v-col style="color: #C72D23;">
          <p>Abbruciamento in deroga al divieto Piano Aria non consentito nel periodo 1° novembre – 29 febbraio (DL n. 29/2023)</p>
          <p>Se vuoi saperne di più: <a href="https://ambiente.regione.emilia-romagna.it/it/parchi-natura2000/foreste/gestione-forestale/abbruciamenti">Abbruciamenti.</a></p>
        </v-col>
      </v-row>
      <v-row v-else-if="selCity /*&& (selCity.pair || selCity.cessato)*/ && blockByDivietoEstivoDL692023">
        <v-col style="color: #C72D23;">
          <p>Abbruciamento non consentito nel periodo luglio-agosto per DL 69/2023</p>
        </v-col>
      </v-row>
      <div v-else>
      <!-- INIZIO DEROGA -->
        <v-row v-if="selCity && selCity.pair && isPairPeriod && this.fire.signaler != 'Scout'">
          <v-col class="fuochi-field-label" cols="12">
            <h5>Abbruciamento in deroga</h5>
            <v-checkbox
                  v-model="fire.pair"
                  :rules="[v => !!v || '(La dichiarazione è obbligatoria per proseguire)']"
                  color="primary"
                  label="al divieto Piano Aria"  
              >
            </v-checkbox>
              <!-- nota: questo div è fuori dalla label altrimenti non funzionano i link al suo interno -->
              <div class="fuochi-sapernedipiu">(se vuoi saperne di più: 
                <a href='https://ambiente.regione.emilia-romagna.it/it/parchi-natura2000/foreste/gestione-forestale/abbruciamenti' target="_blank">Abbruciamenti</a>, 
                <a href='https://www.arpae.it/it/temi-ambientali/aria/liberiamo-laria/bollettino-misure-emergenziali' target="_blank">Bollettino</a>)
              </div>

            <v-checkbox  
                    v-model="fire.deroga"
                    :rules="[v => !!v || '(La dichiarazione è obbligatoria per proseguire)']"
                    color="primary"  
                    class="checkbox-start"
                    style="float: left;"
                >
                    <template v-slot:label>
                      <div class="fuochi-dichiaro-che">
                        <p>Dichiaro che:</p>
                        <ul>
                          <li>ho verificato che ARPAE ha emesso bollino verde (Polveri sottili) per la provincia e il giorno in cui intendo fare l'abbruciamento;</li>
                          <li>non supererò le 2 giornate consentite dal 1° ottobre al 31 marzo;</li>
                          <li>il materiale vegetale da eliminare è in zona non raggiungibile da viabilità ordinaria, ed è in quantitativo non superiore a 3 metri steri (mc) per ettaro.</li>
                          <li v-if="isDivietoDL692023">ho verificato che l’abbruciamento sarà fatto in zona svantaggiata FEARS del Comune.</li>
                        </ul>
                      </div>
                    </template>
                </v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="selCity && (selCity.pair || selCity.cessato) && blockByDivietoDL692023">
          <v-col style="color: #C72D23;">
            <p>Abbruciamento in deroga al divieto Piano Aria non consentito nel periodo 1° novembre – 29 febbraio (DL n. 29/2023)</p>
            <p>Se vuoi saperne di più: <a href="https://ambiente.regione.emilia-romagna.it/it/parchi-natura2000/foreste/gestione-forestale/abbruciamenti">Abbruciamenti.</a></p>
          </v-col>
        </v-row>
        <v-row v-if="selCity && isDivietoEstivoDL692023 && this.fire.signaler != 'Scout'">
          <v-col style="color: #C72D23;">
            <p>Abbruciamento consentito nel periodo di Luglio-Agosto solo nella zona svantaggiata del territorio comunale (DL n. 69/2023).</p>
            <p>Verificare con il Comune o al seguente <a href="https://agricoltura.regione.emilia-romagna.it/sviluppo-rurale-23-27/delimitazioni/zone-svantaggiate" target="_blank">link</a> se la superficie dove si intende fare l'abbruciamento ricade in zona svantaggiata.</p>
          </v-col>
          <v-checkbox
              v-model="fire.dl6923Summer"
              :rules="[v => !!v || '(La dichiarazione è obbligatoria per proseguire)']"
              color="primary"  
              class="checkbox-start"
              style="float: left;"
          >
              <template v-slot:label>
                <div class="fuochi-dichiaro-che">
                  <p>Dichiaro che ho verificato che la superficie in cui intendo fare l'abbruciamento ricade nella zona svantaggiata del Comune.</p>
                </div>
              </template>
          </v-checkbox>
        </v-row>
        <!-- FINE DEROGA -->

        <!-- INIZIO NOTE -->
        <v-col class="nopaddingleft fuochi-field-label" cols="12">
          <h5>Note aggiuntive (non obbligatorie)</h5>
          <div class='fuochi-tooltip-container'>
            <v-tooltip top :close-delay=tooltip.delay>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              {{ tooltip.noteAggiuntive }}
            </v-tooltip>
          </div>
        </v-col>
        <v-row>
          <v-col cols="12">
            <v-textarea
              :aria-label="['Note aggiuntive (non obbligatorie), '+tooltip.noteAggiuntive]"
              outlined
              name="input-7-4"
              :placeholder="'Esempi:\nAccenderò il fuoco nel mio campo per bruciare le sterpaglie.\nMappale dell\'area di abbruciamento.\nAzienda agricola Marco Rossi, Bologna.'"
              v-model="fire.notes"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <!-- FINE NOTE -->

        <!-- ALLEGATI -->
        <v-col class="nopaddingleft fuochi-field-label" cols="12">
          <h5>Allegati</h5>
        </v-col>
        <v-row>
          <v-col cols="12">
            <v-btn
              x-large
              two-line
              color="primary"
              aria-label="aggiungi documenti o foto"
              :loading="isSelectingFiles"
              :disabled="files.length >= 5"
              @click="onButtonClickFiles"
            >
              <v-icon>mdi-paperclip</v-icon>

              Aggiungi documenti o foto
            </v-btn>

            <input
              ref="uploader"
              class="d-none"
              type="file"
              title='allegati'
              accept=".pdf, .jpg, .docx, .png"
              @change="onFileChanged"
            />
          </v-col>
        </v-row>

        <v-col class="nopaddingleft" cols="12">
          &Egrave; possibile allegare documenti in formato pdf, docx, jpg o png.
          Il limite è di 5 allegati per un massimo di 4MB per allegato.
        </v-col>

        <v-row>
          <v-col cols="12">
            <v-list two-line>
              <template v-for="(file, index) in files">
                <v-list-item :key="'file' + index">
                  <v-list-item-content>
                    <v-list-item-title style="width: 80%" class="primary--text">
                      {{ file.name }}
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      aria-label="elimina file"
                      icon
                      @click="OnRemove($event, index)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

                <v-divider v-if="index < files.length" :key="index"></v-divider>
              </template>
            </v-list>
          </v-col>
        </v-row>
        <!-- FINE ALLEGATI -->

        <!-- NORMATIVA - RIMOSSO
      <v-row>
          <v-col 
              cols="12"
                style="display: flex; justify-content: left; padding-bottom: 0px">
              <v-checkbox  
                  required 
                  :rules="[v => !!v || 'Per proseguire è obbligatorio leggere la normativa']"
                  color="primary"  
                  class="pa-0 ma-0"
                  style="float: left; "
              >
                  <template v-slot:label>
                      <a :href="link.normativa" target="_blank" @click.stop>  Ho letto la normativa </a>
                  </template>

              </v-checkbox>
          </v-col>
      </v-row>

      <v-row>
          <v-col 
              cols="12"
                style="display: flex; justify-content: left; padding-top: 0px, padding-bottom: 0px">
              <v-checkbox  
                  required 
                  :rules="[v => !!v || 'Per proseguire è obbligatorio leggere le sanzioni']"
                  color="primary"  
                  class="pa-0 ma-0"
                  style="float: left; "
              >
                  <template v-slot:label>
                      <a :href="link.sanzioni" target="_blank"  @click.stop>
                              Ho letto le sanzioni
                      </a>
                  </template>
              </v-checkbox>
          </v-col>
      </v-row> -->

        <v-row>
          <v-col cols="12" sm="4" offset-sm="2" align="left">
            <template>
              <vue-recaptcha
                @verify="onVerify"
                :sitekey="siteKey"
              ></vue-recaptcha>
            </template>
          </v-col>
          <v-col
            v-if="failedCaptcha && !recaptchaOk"
            cols="12"
            style="margin-top: 0px"
          >
            <v-alert type="error" role="alert">
              Ho bisogno di sapere che non sei un robot.
            </v-alert>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="text-xs-center">
            <v-btn
              block
              x-large
              two-line
              color="primary"
              @click="checkValidationAndConfirm()"
              :loading="isSendingData"
            >
              Invia segnalazione

              <v-icon>mdi-arrow-right-bold</v-icon>
            </v-btn>
          </v-col>
          <div class="my-10"></div>
        </v-row>
      </div>
    </v-form>

    <v-row>
      <v-col cols="12" class="text-left" style="padding-top: 32px">
        <a :href="link.parent" target="_blank">
          Hai dei dubbi? Scrivi o telefonaci
        </a>
      </v-col>
    </v-row>

    <v-row v-show="fire.name == 'beta'" style="border: solid 1px purple">
      <v-col cols="12">
        BETA TEST OTPDIGITS
        <v-otp-input
          input-classes="otp-input"
          separator=" "
          :num-inputs="otpDigits"
          :is-input-num="true"
        />
      </v-col>
    </v-row>

    <div v-if="passValidation && !preAllarmPhase && !offline">
      <v-form>
        <v-row>
          <v-col cols="12">
            <h3>Inserisci il codice ricevuto via SMS</h3>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-otp-input
              v-model="otp"
              ref="otpInput"
              input-classes="otp-input"
              separator=" "
              :num-inputs="otpDigits"
              :should-auto-focus="true"
              :is-input-num="true"
              @on-change="handleOnChange"
              @on-complete="handleOnComplete"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" style="padding-bottom: 0px !important">
            <h3 class="text-left">Non l'hai ancora ricevuto?</h3>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="text-left"
            style="padding-top: 0px !important"
          >
            <a @click="newOtp" style="text-decoration: underline">
              Genera un nuovo codice
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4" offset-sm="2" class="text-xs-center">
            <!-- <v-btn block x-large two-line color="primary" 
              :loading="isSendingData"
              @click="postVerifyOtp()">
              Verifica OTP
            </v-btn> -->
            <v-btn block x-large two-line color="primary" 
              :loading="isSendingData"
              @click="onButtonClickAddFire()">
              Conferma e invia segnalazione
            </v-btn>
          </v-col>
        </v-row>
        <div class="my-10"></div>
        <div class="my-10"></div>
        <v-row>
          <v-col cols="12">
            <h3 class="text-left">Dopo l'invio, riceverai un secondo SMS a conferma dell'avvenuta comunicazione</h3>
          </v-col>
        </v-row>
      </v-form>
    </div>

    <div v-if="postValidationOTP && !offline">
      <v-row>
        <v-col cols="12" md="8" align="center" offset-md="2">
          <img class="center" src="../assets/flame.svg" />
        </v-col>
      </v-row>

      <v-row>
        <v-col style="padding-bottom: 0px" cols="12">
          <h1 class="text-center">Conferma segnalazione</h1>
          <h3 class="text-left">Rivedi e conferma la tua segnalazione.</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="form-review ml-1" cols=12>
          <p><label>Nome:</label> {{ fire.name }}</p>
          <p><label>Cognome:</label> {{ fire.surname }}</p>
          <p><label>Segnalatore:</label> {{ fire.signaler }}</p>
          <p><label>Cellulare:</label> +39 {{ fire.phone }}</p>
          <p><label>Indirizzo/Località:</label> {{ fire.address }}</p>
          <p v-if="fire.streetNumber"><label>Numero civico:</label> {{ fire.streetNumber }}</p>
          <p><label>Provincia:</label> {{ fire.province }}</p>
          <p><label>Comune:</label> {{ fire.city }}</p>
          <p><label>Accensione fuoco:</label> {{ formatDate(fire.dateStart) }} 
          <svg
            class="w-4 h-4 mx-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            width="15"
            heigth="15"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
          {{ formatDate(fire.dateEnd) }}</p>
          <p v-if="fire.postalCode"><label>CAP:</label> {{ fire.postalCode }}</p>
          <p v-if="fire.notes"><label>Note aggiuntive:</label> {{ fire.notes }}</p>
          <p v-if="fire.notes"><label>Allegati:</label></p>
          <ul>
            <template v-for="(file, index) in files">
              <li :key="index">
                {{file.name}} - {{bytesToMegaBytes(file.size)}}Mb
              </li>
            </template>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
            <v-btn block x-large two-line color="primary" 
              :loading="isSendingData"
              @click="onButtonClickAddFire()">
              Conferma e invia segnalazione
            </v-btn>
          </v-col>
        </v-row>
    </div>

    <div v-if="postInsertBurningSignalSuccess && !offline">
      <v-row>
        <v-col cols="12" md="8" align="center" offset-md="2">
          <img class="center" src="../assets/flame.svg" />
        </v-col>
      </v-row>

      <v-row>
        <v-col style="padding-bottom: 0px" cols="12">
          <h1 class="text-center">Grazie per la segnalazione!</h1>
          <h3 class="text-center">Riceverai a breve un secondo SMS,</h3>
          <h3 class="text-center"><b>conservalo</b> come attestazione dell'avvenuta comunicazione.</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col style="padding-top: 0px" cols="12" class="text-center">
          <a @click="newFire" style="text-decoration: underline">
            Devi segnalare un altro fuoco?
          </a>
        </v-col>
      </v-row>
    </div>
    <form-confirm-dialog :fire="fire" :visible="showConfirmDialog" :files="files"
      @confirm="() => { checkValidation(); showConfirmDialog = false; }"
      @cancel="() => { showConfirmDialog = false; }"
    ></form-confirm-dialog>
  </v-container>
</template>

<script>
import dateTimeFilters from "@/mixins/date-time-filters";
import dateTimeConvertion from "@/mixins/date-time-convertion";
import { burningSignalService } from "@/services/BurningSignal";
import { attachmentsService } from "@/services/Attachments";
import { otpService } from "@/services/Otp";
import { uuid } from "vue-uuid";
import { OTPDIGITS, RECAPTCHASITEKEY, OFFLINEREDIRECT, VERSION } from "../config/config";
import VueRecaptcha from "vue-recaptcha";
import moment from "moment";
moment.locale("it");

export default {
  name: "form-fire",
  mixins: [dateTimeFilters, dateTimeConvertion],
  components: { VueRecaptcha },
  data: () => ({
    files: [],
    idFile: 0,
    fires: [],
    selectedFile: null,
    windowWidth: window.innerWidth,
    isSelectingFiles: false,
    isSendingData: false,
    siteKey: RECAPTCHASITEKEY,
    otpDigits: OTPDIGITS.length,
    otp: null,
    otpId: 0,
    cities: [],
    provinces: [],

    dataValidContent: true, 

    valid: false,
    passValidation: false,
    failedCaptcha: false,
    recaptchaOk: false,
    captchaValidationCode: null,
    postValidationOTP: false,
    postInsertBurningSignalSuccess: false,
    preAllarmPhase: false,
    warningPhase: false,
    phaseMessage: "",
    showConfirmDialog: false,

    dateStartMenuOpen: false,
    timeStartMenuOpen: false,
    dateEndMenuOpen: false,
    timeEndMenuOpen: false,
    hasMaxDateEnd: false,
    hasMaxTimeEnd: false,
    maxDateEnd: null,
    maxTimeEnd: null,
    maxDate: new Date(2300, 0, 1),
    minDate: new Date(1950, 0, 1),
    
    formIsOffline: true,

    link: {
      normativa: "https://www.google.com/search?q=normativa", // non utilizzato
      sanzioni: "https://www.google.com/search?q=sanzioni", // non utilizzato
      parent: "https://ambiente.regione.emilia-romagna.it/it/parchi-natura2000/foreste/gestione-forestale/abbruciamenti",
    },
    tooltip: {
      delay: 100, // ritardo alla chiusura del tooltip in millisecondi
      nameSurname:
        "Inserisci i dati di chi è autorizzato a fare l'abbruciamento (proprietario/affittuario del terreno)",
      phone:
        "A questo numero verrà inviato un codice di verifica che ti servirà per concludere la segnalazione",
      address:
        "Inserisci l'indirizzo/località di dove verrà eseguita l'operazione di abbruciamento",
      datetime:
        "Per Privato cittadino e Azienda Agricola: data/ora di inizio e fine devono essere ricomprese nelle 48 ore a partire da questa comunicazione",
      datetimeWarning:
        "\nIn fase di attenzione per rischio incendi vige il divieto di abbruciamento dopo le ore 11:00 di mattina",
      noteAggiuntive:
        "Indicare il numero di telefono di reperibilità del responsabile dell'abbruciamento, se diverso dal numero di cellulare già inserito sopra",
      city:
        "Contatta il Comune per conoscere eventuali provvedimenti restrittivi locali",
    },
    selCity: null,
    pairPeriod: {},
    divietoDL692023Period: {},
    divietoEstivoDL692023Period: {},
    warningState: {
      enabled: false,
      provinces: [],
      zonaIBs: []
    },
    preAllarmState: {
      enabled: false,
      provinces: [],
      zonaIBs: []
    },
    offline: true,
    isLoadingState: true,
    isPairPeriod: false,
    blockByDivietoDL692023: false,
    isDivietoDL692023: false,
    blockByDivietoEstivoDL692023: false,
    isDivietoEstivoDL692023: false,
    fire: {
      name: null,
      surname: null,
      signaler: null,
      phone: null,
      email: null,
      address: null,
      streetNumber: null,
      province: null,
      postalCode: null,
      dateStart: null,
      dateEnd: null,
      
      pair: false,
      deroga: false,
      dl6923: false,
      dl6923Summer: false,
      notes: null,

      guid: null,
    },
    choicesSignaler: ["Privato cittadino", "Azienda agricola", "Soggetti pubblici e istituzioni", "Scout"],
  }),
  methods: {
    isEmailValid(email) {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegex.test(email);
    },
    checkIsPairPeriod() {
      if (!this.fire.dateStart || !this.fire.dateEnd || !this.pairPeriod.start) { this.isPairPeriod = false; return; }
      const pairStart = moment(this.pairPeriod.start, "DD/MM/YYYY"); 
      const pairEnd = moment(this.pairPeriod.end, "DD/MM/YYYY");
      const fireStart = moment(this.fire.dateStart); 
      const fireEnd = moment(this.fire.dateEnd);
      // this.isPairPeriod = 
      //   fireStart.isBetween(pairStart, pairEnd) // questo confronto non include gli estremi 
      //   || fireEnd.isBetween(pairStart, pairEnd) 
      //   || pairStart.isBetween(fireStart, fireEnd);
      // fix per date agli estremi
      this.isPairPeriod =
        fireStart.isBetween(pairStart, pairEnd) ||
        fireEnd.isBetween(pairStart, pairEnd) ||
        fireStart.isSame(pairStart, "day") ||
        fireStart.isSame(pairEnd, "day") ||
        fireEnd.isSame(pairStart, "day") ||
        fireEnd.isSame(pairEnd, "day");
    },
    checkIsDivietoDL692023() {
      if (!this.isPairPeriod || !this.selCity || !this.fire.dateStart || !this.fire.dateEnd || !this.divietoDL692023Period.start) { this.isDivietoDL692023 = false; this.blockByDivietoDL692023 = false; return; }
      const divietoStart = moment(this.divietoDL692023Period.start, "DD/MM/YYYY");
      const divietoEnd = moment(this.divietoDL692023Period.end, "DD/MM/YYYY");
      const fireStart = moment(this.fire.dateStart); 
      const fireEnd = moment(this.fire.dateEnd);

      divietoStart.year(fireStart.year());
      divietoEnd.year(fireStart.year());

      const isPeriod = (divietoEnd.isAfter(divietoStart) && (
          fireStart.isBetween(divietoStart, divietoEnd) ||
          fireEnd.isBetween(divietoStart, divietoEnd) ||
          fireStart.isSame(divietoStart, "day") ||
          fireStart.isSame(divietoEnd, "day") ||
          fireEnd.isSame(divietoStart, "day") ||
          fireEnd.isSame(divietoEnd, "day")
        )) || (
          fireStart.isSameOrBefore(divietoEnd) ||
          fireStart.isSameOrAfter(divietoStart) ||
          fireEnd.isSameOrBefore(divietoEnd) ||
          fireEnd.isSameOrAfter(divietoStart)
        )

      this.blockByDivietoDL692023 = isPeriod && this.selCity.divietoDL692023 == "Non svantaggiato";
      this.isDivietoDL692023 = isPeriod && this.selCity.divietoDL692023 == "Parzialmente non svantaggiato";
      this.confirmDL6923();
    },
    checkIsDivietoEstivoDL692023() {
      if (!this.selCity || !this.fire.dateStart || !this.fire.dateEnd || !this.divietoEstivoDL692023Period?.start) { this.isDivietoEstivoDL692023 = false; this.blockByDivietoEstivoDL692023 = false; return; }
      const divietoStart = moment(this.divietoEstivoDL692023Period.start, "DD/MM/YYYY");
      const divietoEnd = moment(this.divietoEstivoDL692023Period.end, "DD/MM/YYYY");
      const fireStart = moment(this.fire.dateStart); 
      const fireEnd = moment(this.fire.dateEnd);

      divietoStart.year(fireStart.year());
      divietoEnd.year(fireStart.year());

      const isPeriod = (divietoEnd.isAfter(divietoStart) && (
          fireStart.isBetween(divietoStart, divietoEnd) ||
          fireEnd.isBetween(divietoStart, divietoEnd) ||
          fireStart.isSame(divietoStart, "day") ||
          fireStart.isSame(divietoEnd, "day") ||
          fireEnd.isSame(divietoStart, "day") ||
          fireEnd.isSame(divietoEnd, "day")
        )) || (
          (fireStart.isSameOrBefore(divietoEnd) &&
          fireStart.isSameOrAfter(divietoStart)) ||
          (fireEnd.isSameOrBefore(divietoEnd) &&
          fireEnd.isSameOrAfter(divietoStart))
        )

      this.blockByDivietoEstivoDL692023 = isPeriod && ( this.selCity.zonaPair == 'PianuraOvest') && this.selCity.divietoEstivoDL692023 == "Non svantaggiato";
      this.isDivietoEstivoDL692023 = isPeriod && ( this.selCity.zonaPair == 'PianuraOvest') && this.selCity.divietoEstivoDL692023 == "Parzialmente non svantaggiato";
  
    },
    confirmDL6923() {
      this.fire.dl6923 = this.isDivietoDL692023;
    },
    /*
      VALIDAZIONE DATE
      V1) Sempre inibito l'inserimento di una data inizio prima della data corrente.
      Per i cittadini/aziende agricole: 
        V2) La data di inizio deve essere compresa tra la data corrente+48 ore al massimo 
        V3) La data di fine evento deve essere comunque entro 48 ore dalla data corrente
      Per gli scout: 
        V4) La data di inizio può essere dalla data corrente in poi, senza limiti
        V5) Non c'è limite alla data di fine evento
      Ovviamente:
        V6) Data fine sempre maggiore di data inizio
    */
    verifyDates() {
      // verifica di coerenza date

      if (this.fire.dateStart) {
        if (this.fire.dateStart.getTime() < this.getStartDateMin().getTime()) {
          this.fire.dateStart = this.getStartDateMin();
        }
        if (this.fire.dateStart.getTime() > this.getStartDateMax().getTime()) {
          this.fire.dateStart = this.getStartDateMax();
        }
      }

      if (this.fire.dateStart && this.fire.dateEnd) {
        if (this.fire.dateEnd.getTime() < this.fire.dateStart.getTime()) {
          // V6) Data fine sempre maggiore di data inizio
          this.fire.dateEnd = new Date(this.fire.dateStart.getTime());
        } else if (this.fire.dateEnd.getTime() > this.getEndDateMax()) {
          this.fire.dateEnd = this.getEndDateMax();
        }
        this.checkIsPairPeriod();
        this.checkIsDivietoDL692023();
        this.checkIsDivietoEstivoDL692023();
      }

    },
    getEndDateMin() {
      if (this.fire.dateStart) {
        return this.fire.dateStart;
      } else {
        return new Date();  
      }
    },
    getEndDateMax() {
      if (this.fire.signaler != "Scout") {
        // V3) La data di fine evento deve essere comunque entro 48 ore dalla data corrente
        //return new Date(this.fire.dateStart.getTime()+ 48 * 60 * 60 * 1000)
        let twoDays = new Date((new Date()).getTime() + 48 * 60 * 60 * 1000);
        twoDays.setHours(23,59,0,0);
        return twoDays;
      } else {
        // V5) Per scout non c'è limite alla data di fine evento
        return new Date((new Date()).getFullYear()+2, 0, 1); 
      }
    },
    getStartDateMin() {
      // V1) Sempre inibito l'inserimento di una data inizio prima della data corrente
      return new Date();
    },
    getStartDateMax() {
      if (this.fire.signaler != "Scout") {
        // V2) La data di inizio deve essere compresa tra la data corrente+48 ore al massimo
        let twoDays = new Date((new Date()).getTime() + 48 * 60 * 60 * 1000);
        twoDays.setHours(23,59,0,0);
        return twoDays;
      } else {
        // V4) Per scout la data di inizio può essere dalla data corrente in poi, senza limiti
        return new Date((new Date()).getFullYear()+2, 0, 1); 
      }
    },
    onButtonClickFiles() {
      this.isSelectingFiles = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelectingFiles = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      // this.selectedFile.id = this.idFile++;
      var ok = false;
      var fileExtension = this.selectedFile.name.split('.').pop().toLowerCase();
      var accepted = this.$refs.uploader.accept.split(",");
      for (var i = 0; i < accepted.length; i++) {
          var ext = accepted[i].trim().toLowerCase();
          if ("."+fileExtension == ext) {
            ok = true;
            break;
          }
      }

      if (ok)
        this.files.push(this.selectedFile);
      else {
        this.$store.state.errorDialog = true;
        this.$store.state.errorDialogMessages = [
          "Non è possibile caricare il file '" +
            this.selectedFile.name +
            "'. Verificare i criteri previsti.",
        ];
      }
      //console.log("files", this.files);
      // console.log(JSON.stringify(e.target));

      // do something
    },
    goToAllFires() {
      // console.log("fires: " + JSON.stringify(this.fires));
      this.$router.push({
        path: "/fires-list",
      });
    },
    newFire() {
      this.fires = this.$store.getters.fires;
      this.fire = {};
      this.selCity = null;
      this.postInsertBurningSignalSuccess = false;
    },
    async newOtp() {
      //console.log("sto generando nuovo otp");
      this.$refs.otpInput.clearInput();
      await this.generateOtp();
    },
    onVerify: function (response) {
      this.captchaValidationCode = response;
      this.recaptchaOk = true;
    },
    handleOnComplete(value) {
      //console.log("OTP completed: ", value);
      this.otp = value;
      //console.log("otp: " + this.otp);
    },
    handleOnChange(value) {
      //console.log("OTP changed: ", value);
      this.otp = value;
      //console.log("otp: " + this.otp);
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
    },
    async verifyOtp() {
      await otpService
        .postVerifyOtp(
          this.captchaValidationCode,
          this.otp,
          this.fire.phone,
          this.otpId
        )
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    async generateOtp() {
      await otpService
        .postGenerateOtp(this.captchaValidationCode, this.fire.phone)
        .then((res) => {
          this.otpId = res.data.Id;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async checkValidationAndConfirm() {
      if (this.$refs.form.validate()) {
        this.showConfirmDialog = true;
      } else {
        this.$store.state.errorDialog = true;
        this.$store.state.errorDialogMessages = ["Dati non validi", "Verificare i dati immessi"]
      }
    },
    async checkValidation() {
      this.isSendingData = true;
      if (this.$refs.form.validate()) {
        this.fire.version = VERSION;
        let valid = true;
        try {
          const valCall = await burningSignalService.postValidateBurningSignal(this.captchaValidationCode, JSON.parse(JSON.stringify(this.fire)), "{\"files\":[]}");
        } catch {
          valid = false;
        }
        if (valid) {
          this.dataValidContent = true;
          if (this.fire.name == "beta") {
            // ok validazione client side
            // la validazione server side passa solo in DEBUG
            this.recaptchaOk = true;
          }

          if (this.recaptchaOk) {
            this.passValidation = true;
            await this.generateOtp();
          } else {
            this.failedCaptcha = true;
          }
        }
      } else {
        //console.log("Form non valido");
        this.$store.state.errorDialog = true;
        this.$store.state.errorDialogMessages = ["Dati non validi", "Verificare i dati immessi"]
        this.dataValidContent = false;
        // window.document.location = "#anchorgenericAlertDataValidContent";
      }
      this.isSendingData = false;
    },
    async initPhases() {
      this.preAllarmPhase = false;
      this.warningPhase = false;
      this.phaseMessage = "Non è possibile inserire una segnalazione in fase di pre-allarme";
    },
    OnRemove(e, index) {
      this.files.splice(index, 1);
    },
    addDocuments() {
      //console.log("click su aggiungi documenti o foto");
    },
    bytesToMegaBytes(bytes) { 
      return Math.round((bytes / (1024*1024)) * 100) / 100; 
    },
    async postVerifyOtp() {
      this.isSendingData = true;
      try {
        const otpResp = await otpService
        .postVerifyOtp(
          this.captchaValidationCode,
          this.otp,
          this.fire.phone,
          this.otpId
        );
        if (otpResp.status == 200) {
          this.passValidation = false;
          this.postValidationOTP = true;
        }
        console.log("otpResp", otpResp);
      } catch(err) {
        console.log(err);
      }
      this.isSendingData = false;
    },
    async onButtonClickAddFire() {
      
      this.isSendingData = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSendingData = false;
        },
        { once: true }
      );
      
      //console.log("this.fire.guid: " + this.fire.guid);
      this.fire.version = VERSION;
      let fire = JSON.parse(JSON.stringify(this.fire));
      attachmentsService
        .attachFiles(
          this.captchaValidationCode, 
          this.otp,
          this.fire.phone,
          this.otpId,
          this.files)
        .then((resAttach) => {
          //console.log("resAttach", resAttach);
          burningSignalService
            .postInsertBurningSignal(
              this.captchaValidationCode,
              this.otp,
              this.otpId,
              fire,
              resAttach.data
            )
            .then((res) => {
              this.passValidation = false;
              this.postValidationOTP = false;
              this.postInsertBurningSignalSuccess = true;
              this.$store.commit("change", fire);
              this.isSendingData = false;
            })
            .catch((err) => {
              this.isSendingData = false;
              this.passValidation = false;
              console.log(err);
            });
        })
        .catch((err) => {
          this.isSendingData = false;
          this.passValidation = false;
          console.log(err);
        });
    },
    async loadProvinces() {
      await burningSignalService
        .getProvinceList()
        .then((res) => {
          this.provinces = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async loadDistricts(provincia) {
      if (!provincia) {
        provincia = this.fire.province
      }
      await burningSignalService
        .getDistrictsList(provincia)
        .then((res) => {
          //console.log("getDistrictsList", res.data);
          this.cities = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async loadPairPeriod() {
      try {
        let pairPeriod = await burningSignalService.getPairPeriod();
        this.pairPeriod = pairPeriod?.data ?? {};
      } catch(e) {
        console.error(e);
        this.pairPeriod = {};
      }
    },
    async loadDivietoDL692023Period() {
      try {
        let period = await burningSignalService.getDivietoDL692023Period();
        this.divietoDL692023Period = period?.data ?? {};
      } catch(e) {
        console.error(e);
        this.pairPeriod = {};
      }
    },
    async loadDivietoEstivoDL692023Period() {
      try {
        let period = await burningSignalService.getDivietoEstivoDL692023Period();
        this.divietoEstivoDL692023Period = period?.data ?? {};
      } catch(e) {
        console.error(e);
        this.divietoEstivoDL692023Period = {};
      }
      
    },
    async loadPreAllarmPeriod() {
      let preAllarmPeriod = await burningSignalService.getPreAllarmPeriod();
      this.preAllarmPeriod = preAllarmPeriod.data;
    },
    formatDate(date) {
      if (date) {
        let mdate = moment(date);
        if (mdate && mdate.isValid()) {
          return mdate.format("DD/MM/YYYY HH:mm");
        }
      }
      return "";
    },
    async getCurrentState() {
      const currentState = (await burningSignalService.getCurrentState()).data;
      //console.log("currentState", currentState);
      for (let i = 0; i < currentState.length; i++) {
        const state = currentState[i];
        switch (state.state) {
          case 'Attenzione':
            this.warningState.enabled = true;
            this.warningState.provinces = state.provinces || [];
            this.warningState.zonaIBs = state.zonaIBs || [];
            break;
          case 'PreAllarme':
            this.preAllarmState.enabled = true;
            this.preAllarmState.provinces = state.provinces || [];
            this.preAllarmState.zonaIBs = state.zonaIBs || [];
            break;
          case 'Offline':
            //window.location.href = OFFLINEREDIRECT;
            this.isLoadingState = false;
            return false;
        }
      }
      this.isLoadingState = false;
      this.offline = false;
      return true;
    },
  },
  computed: {
    currentFire() {
      return this.$store.getters.currentFire;
    },
  },
  async mounted() {
    console.log("ver. 1");
    if (!(await this.getCurrentState())) {
      return;
    }
    this.fire.guid = uuid.v4();
    await this.loadPairPeriod();
    await this.loadDivietoDL692023Period();
    await this.loadDivietoEstivoDL692023Period();
    await this.loadProvinces();
    this.initPhases();

    this.fires = this.$store.getters.fires;

    if (this.currentFire != undefined) {
      
      // console.log("Compila form da dati precedenti", this.currentFire);

      await this.loadDistricts(this.currentFire.province); // devi aver già letto la provincia

      var city = { "nome": this.currentFire.city, "pair": false }
      // cerca la città se è tra i comuni pair
      this.cities.forEach(function(elem) {
        if (elem.nome == city.nome) { 
          city.pair = elem.pair;
          city.divietoDL692023 = elem.divietoDL692023;
          city.divietoEstivoDL692023 = elem.divietoEstivoDL692023;
          city.cessato = elem.cessato;
        }
      });

      this.selCity = city;
      this.currentFire.city = city.nome;

      // questi valori vengono tutti azzerati perché non devono essere presi dallo storico
      this.currentFire.pair = false;
      this.currentFire.deroga = false;
      this.currentFire.dl6923Summer = false;
      this.currentFire.guid = null;
      this.currentFire.dateStart = null;
      this.currentFire.timeStart = null;
      this.currentFire.dateEnd = null;
      this.currentFire.timeEnd = null;
      this.currentFire.notes = null;

      this.fire = this.currentFire;
      
      this.isPairPeriod = false; // verrà aggiornato dopo aver selezionato le date del fuoco

      this.$refs.form.resetValidation();
    }
    //console.log("guid: " + this.fire.guid);
  },
};
</script>

<style>
.v-icon.v-icon {
  font-size: 20px !important;
  color: #666666;
}

.otp-input {
  width: 56px;
  height: 56px;
  padding: 10px;
  margin-right: 8px;
  font-size: 30px;
  border-radius: 4px;
  border: 1px solid #666666;
  text-align: center;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  color: red;
  margin: 0;
}

.v-text-field__details {
  padding-left: 0px !important;
}

.nopadding {
  padding-left: 0px !important;
  padding-bottom: 5px !important;
}

.nopaddingleft {
  padding-left: 0px !important;
}

.nopaddingBottomAndTop {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.right-input input {
  text-align: right;
  margin-bottom: 0px !important;
}

input[type="tel" i]:focus {
  outline: none !important;
  border: 1px solid #cb1d15 !important;
}

input {
  font-size: 18px;
}

h5 {
  font-weight: normal;
  font-size: 18px;
}

h2 {
  font-weight: normal;
}

h3 {
  font-weight: normal;
}

.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 50px !important;
}

.v-input .v-label {
  line-height: 15px !important;
}

label.v-label, .theme--light.v-label {
    color: black !important;
}
div.fuochi-sapernedipiu {
    /* margin-top: -10px; */
    margin-left: 1em;
    display: block;
}
.fuochi-sapernedipiu a {
    font-size: 16px !important;
}

.fuochi-dichiaro-che li {
    line-height: 1.5rem;
}


/* questo stile fissa il tooltip per sempre e non scompare più!
.v-tooltip__content {
  opacity: 1 !important;
  max-width: 70%;
  display: block !important;
} */
.v-tooltip__content {
  min-width: 360px;
  max-width: 360px;
}

.fuochi-field-label { 
	position: relative; 
}
.fuochi-tooltip-container { 
  position: absolute;
  text-align: right;
  width: 100%;
  top: 1em;
}


/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.checkbox-start .v-input__slot {
  align-items: start;
}

.form-review p {
  margin-bottom: 8px;
}

.form-review p label {
  font-weight: bold;
}

.allarmState p {
  margin-bottom: 0;
}

.section-fitosanitari {
  padding: 8px;
  background: #eeeeee;
  margin: 0;
  margin-bottom: 16px !important;
  padding-left: 80px;
  font-size: 16px;
}

/* LOADER SPINNER */
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #888;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
/* LOADER SPINNER */

</style>
